var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 9.85352H6.375V13.6035H12.375V9.85352Z",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 9.85352V7.60352C7.87619 7.20606 8.0346 6.82521 8.31565 6.54417C8.5967 6.26312 8.97754 6.1047 9.375 6.10352C9.77246 6.1047 10.1533 6.26312 10.4343 6.54417C10.7154 6.82521 10.8738 7.20606 10.875 7.60352V9.85352",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 11.3535C16.125 13.1437 15.4138 14.8606 14.148 16.1265C12.8821 17.3924 11.1652 18.1035 9.375 18.1035C7.58479 18.1035 5.8679 17.3924 4.60203 16.1265C3.33616 14.8606 2.625 13.1437 2.625 11.3535V3.85352L9.375 2.35352L16.125 3.85352V11.3535Z",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.75ce58defcbfec6183387a0e356d24cc.svg";
export { ForwardRef as ReactComponent };